import { useMutation } from "react-query";
import { deleteSafe } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteSafe = () => {
  return useMutation(deleteSafe);
};
export default useDeleteSafe;
